import './main.less';
import React from 'react';
import PropTypes from 'prop-types';

import Select from '../../shared/form-elements/select/select';

const Groups = ({
	intl,
	groupsSelectControls,
	groupsSelectOptions,
	groupsSelectValue,
	groupsSwitchOrder
}) => (
	<div className="groups-filter clearfix">
		<div className="groups-filter__position">
			<div className="form-element-select-improve">
				<Select
					placeholder={intl(groupsSelectControls.first.placeholder)}
					value={groupsSelectControls.first.value}
					options={groupsSelectOptions}
					name={groupsSelectControls.first.name}
					searchable={false}
					onChange={ value => groupsSelectValue(groupsSelectControls.first.name, value) } />
			</div>
		</div>

		<div className="groups-filter__position switch-group-control">
			<button
				className="ui-btn ui-btn-secondary groups-switch"
				onClick={() => groupsSwitchOrder()}/>
		</div>

		<div className="groups-filter__position">
			<div className="form-element-select-improve">
				<Select
					placeholder={intl(groupsSelectControls.second.placeholder)}
					value={groupsSelectControls.second.value}
					options={groupsSelectOptions}
					name={groupsSelectControls.second.name}
					searchable={false}
					onChange={ value => groupsSelectValue(groupsSelectControls.second.name, value) }/>
			</div>
		</div>
	</div>
);

Groups.propTypes = {
	intl: PropTypes.func,
	groupsSelectControls: PropTypes.object,
	groupsSelectOptions: PropTypes.array,
	groupsSelectValue: PropTypes.func,
	groupsSwitchOrder: PropTypes.func
};

export default Groups;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/groups/main.js